module.exports = __webpack_public_path__ + "img/dashboard_created.04c13671.svg";